import { useEffect, useState } from "react";

export default function useContentSize(callback, deps) {
  const [contentSize, setContentSize] = useState({
    width: undefined,
    height: undefined,
  });

  useEffect(() => {
    const container = document.querySelector('body');

    function handleResize() {
      const newWidth = container.offsetWidth;
      const newHeight = container.offsetHeight;

      if (newWidth !== contentSize.width || newHeight !== contentSize.height) {
        setContentSize({ width: newWidth, height: newHeight });
      }
    }

    handleResize();
    const observer = new ResizeObserver(handleResize);
    observer.observe(container);

    return () => observer.disconnect();
  }, [contentSize]);

  return contentSize;
}
